<app-main-layout>
  <app-team-view-page></app-team-view-page>
</app-main-layout>
